import React from "react";

import {
    View,
    Text,
    TextStyle,
    TouchableOpacity,
    Linking
} from "react-native";
import AppTheme from "../../utils/Theme";
import Markdown from "../../../specific/components/Markdown/Markdown";
import { updateSuperPowersOrder } from "../../services/Firebase/Database";

const universalLinksTarget: {value: string, label:string}[] = [
    {
        value:"activity", label:"Activité"
    }
]

interface LHQDocumentationProps {
    goBack?: () => void
}

const LHQDocumentation = (props: LHQDocumentationProps) => {

    const appTheme: AppTheme = new AppTheme;

    const { goBack } = props;

    const h1Style: TextStyle = {
        fontFamily: appTheme.primaryBoldFont,
        color: appTheme.darkBlue,
        fontSize: appTheme.pixelPerfectForFont(18)
    }

    const h2Style: TextStyle = {
        fontFamily: appTheme.primaryMediumFont,
        color: appTheme.darkBlue,
        fontSize: appTheme.pixelPerfectForFont(16)
    }

    const pStyle: TextStyle = {
        fontFamily: appTheme.primaryFont,
        color: appTheme.textColor,
        fontSize: appTheme.pixelPerfectForFont(14)
    }

    const aStyle: TextStyle = {
        fontFamily: appTheme.primaryFont,
        color: appTheme.textColor,
        fontSize: appTheme.pixelPerfectForFont(14),
        textDecorationLine: "underline"
    }

    const getSubTypeSelection = () => {
        let subTypeOptions: { value: string, label: string }[] = [];
        for (const aSubTypeKey in subCaracteristics) {
            if (Object.prototype.hasOwnProperty.call(subCaracteristics, aSubTypeKey)) {
                const element = subCaracteristics[aSubTypeKey];
                subTypeOptions.push({
                    value: aSubTypeKey,
                    label: aSubTypeKey
                })
            }
        }
        return <Select
            onChange={(e) => setSubType(e.value)}
            styles={{
                control: (baseStyles, state) => ({
                    ...baseStyles,
                    height: appTheme.pixelPerfect(30),
                    borderRadius: appTheme.pixelPerfect(10),
                    fontFamily: appTheme.primaryFont
                }),
                option: (styles, { data, isDisabled, isFocused, isSelected }) => ({
                    ...styles,
                    fontFamily: appTheme.primaryFont
                })
            }} options={subTypeOptions} />
    }

    return <View>
        <View style={{ flexDirection: "row" }}>
            <TouchableOpacity onPress={() => goBack()}>
                <Text style={[aStyle, { fontSize: appTheme.pixelPerfectForFont(8), paddingEnd: appTheme.pixelPerfect(5) }]}>
                    Dashboard
                </Text>
            </TouchableOpacity>
            <Text style={[pStyle, { fontSize: appTheme.pixelPerfectForFont(8), paddingEnd: appTheme.pixelPerfect(5) }]}>
                {">"}
            </Text>
            <Text style={[pStyle, { fontSize: appTheme.pixelPerfectForFont(8), paddingEnd: appTheme.pixelPerfect(5) }]}>
                Documentation
            </Text>
        </View>
        <Text style={h1Style}>
            Documentation
        </Text>

        <View>
            <Text style={h2Style}>
                Gestion des Universals Links
            </Text>
            <View style={{ flexDirection: "row" }}>
                <Text style={[pStyle, { paddingEnd: appTheme.pixelPerfect(10) }]}>
                    Amplitude (Analytics)
                </Text>


            </View>
        </View>
    </View>

}

export default LHQDocumentation;